export default "__VITE_ASSET__CD8NkGK0__"